<template>
  <button :type="htmlType" :class="classes" :disabled="disabled" @click="_handleClick">
    <t-icon v-if="loading" :class="`${$constants.PREFIX_ICON_CLASS}ani-loop`" type="loading"></t-icon>
    <t-icon v-if="icon && !loading" :type="icon"></t-icon>
    <span v-if="showSlot" ref="slot"><slot></slot></span>
  </button>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import TIcon from '../icon'

const PREFIX_BUTTON_CLASS = `${PREFIX_CLASS}btn`

export default {
  name: 'TButton',
  components: {TIcon},
  props: {
    loading: Boolean,
    disabled: Boolean,
    icon: String,
    block: {
      type: Boolean,
      default: false
    },
    htmlType: {
      default: 'button',
      type: String,
      validator (value) {
        return [ 'button', 'submit', 'reset' ].includes(value)
      }
    },
    shape: {
      type: String,
      default: '',
      validator (value) {
        return [ 'circle', 'round', '' ].includes(value)
      }
    },
    size: {
      type: String,
      default: '',
      validator (value) {
        return [ 'sm', 'lg', '' ].includes(value)
      }
    },
    type: {
      type: String,
      validator (value) {
        return [ 'primary', 'secondary', 'success', 'info', 'warning', 'danger', 'outline', 'outline-primary', 'outline-secondary', 'outline-success', 'outline-info', 'outline-warning', 'outline-danger', 'outline-white' ].includes(value)
      },
      default: 'secondary'
    }
  },
  data () {
    return {
      showSlot: true,
      clicking: false
    }
  },
  computed: {
    classes () {
      return [
        `${PREFIX_BUTTON_CLASS}`,
        {
          [`${PREFIX_BUTTON_CLASS}-${this.type}`]: !!this.type,
          [`${PREFIX_BUTTON_CLASS}-${this.type}-secondary`]: !!this.type && this.type === 'outline',
          [`${PREFIX_BUTTON_CLASS}-block`]: this.block,
          [`${PREFIX_BUTTON_CLASS}-${this.shape}`]: !!this.shape,
          [`${PREFIX_BUTTON_CLASS}-${this.size}`]: !!this.size,
          [`${PREFIX_BUTTON_CLASS}-loading`]: this.loading != null && this.loading,
          [`active`]: this.clicking != null && this.clicking,
          [`${PREFIX_BUTTON_CLASS}-icon-only`]: !this.showSlot && (!!this.icon || this.loading)
        }
      ]
    }
  },
  mounted () {
    this.showSlot = this.$slots.default !== undefined
  },
  methods: {
    _handleClick (event) {
      this.clicking = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => (this.clicking = false), 500)
      this.$emit('click', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// button.vue?8380ac48